import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedDatePipe } from './date.pipe';

@NgModule({
  imports: [CommonModule],
  declarations: [SharedDatePipe],
  providers: [SharedDatePipe],
  exports: [SharedDatePipe],
})
export class SharedPipesDateModule {}
